import React, { Component } from "react";
import { Link } from "react-router-dom";
import { gaRemoveFromCart } from "../../../Tracking/Tracking";
import { formatPrice } from "../../../../utils/formatPrice";

const CartHeader = ({ item, total, symbol, removeFromCart }) => (
  <li>
    <div className="media">
      <Link to={`${process.env.PUBLIC_URL}/product/${item.product._id}`}>
        <img
          alt=""
          className="mr-3"
          src={`${item?.product?.product_images?.[0]?.image}`}
        />
      </Link>
      <div className="media-body">
        <Link to={`${process.env.PUBLIC_URL}/product/${item.product._id}`}>
          <h4>{item.product.product_name}</h4>
        </Link>
        <h4>
          <span>
            {item.quantity} x {formatPrice(item.product.product_price)}
          </span>
        </h4>
      </div>
    </div>
    {/*<span>{cart}</span>*/}
    <div className="close-circle">
      <a
        href={null}
        onClick={() => {
          removeFromCart();
          gaRemoveFromCart(item.product, item.quantity);
        }}
      >
        <i className="fa fa-times" aria-hidden="true" />
      </a>
    </div>
  </li>
);

export default CartHeader;
